var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_intro)?_c('div',{staticClass:"loading"},[_c('video',{attrs:{"autoplay":"","muted":"","loop":"","src":"/wp-content/uploads/2019/01/slant-ident-full.mp4"},domProps:{"muted":true}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }